module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Italic.67f1c5d6.ttf";